import { cn } from '@/utils/cn'
import { Button } from '../common/button'
import { ExternalLinkIcon } from '../icons/externalLink'
import { CaseStudiesDialog } from './caseStudiesDialog'

export const SidebarApiPromoCard = () => (
  <aside
    className={cn(
      'relative isolate flex flex-col gap-3 overflow-hidden rounded-2xl border bg-surface p-3 pt-5',
      'after:-z-10 after:pointer-events-none after:absolute after:inset-0 after:bg-[-40%_10%] after:bg-[radial-gradient(ellipse_at_35%_45%,transparent_38%,#0DA2FF_65%,#0073FF)] after:bg-[size:135%_340%] after:[mask-image:linear-gradient(to_right,transparent_25%,black)]'
    )}
  >
    <div className="flex flex-col gap-1">
      <h2 className="font-medium text-heading-foreground text-sm">Build products using vaults.fyi API</h2>
      <p className="text-body-foreground text-xs">
        Learn how companies like Kraken, Jumper, Gauntlet, kpk & Maple use our data, transaction payloads & portfolio
        tracking.
      </p>
    </div>

    <CaseStudiesDialog
      trigger={
        <Button
          variant="default"
          size="default"
          className="ml-auto gap-1 rounded-lg pl-1 hocus:text-accent-hover text-accent text-xs hocus:underline"
        >
          <span>See what’s possible</span>
          <ExternalLinkIcon />
        </Button>
      }
    />
  </aside>
)
